import { Authorization } from "../../common/utils/authorization";

export class CommonApis {
  constructor(private url: string, private authKeeper: Authorization) {}
  addIfFound(newObj: any, key: string, value: any, errorObj: { [key: string]: any }, required: boolean) {
    if (typeof value !== "undefined") {
      if (value !== null) {
        newObj[key] = value;
      } else {
        if (required) {
          errorObj[key] = false;
        }
      }
    } else {
      if (required) {
        errorObj[key] = false;
      }
    }
  }

  async verifyMobile(args: {
    mobile: string;
  }): Promise<{
    result?: { offerAvailable?: boolean; token?: string };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "mobile", args.mobile, errorObj, true);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/common-api/offer-identification`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            resolve(res);
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async resendOTP(args: {
    mobile: string;
  }): Promise<{ result?: {}; error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } } }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "mobile", args.mobile, errorObj, true);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/common-api/resend-otp`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async verifyOTP(args: {
    mobile: string;
    otp: string;
  }): Promise<{
    result?: {
      offers?: Array<{
        losAppId?: string;
        promoCode?: string;
        customerId?: string;
        typeOfCustomer?: string;
        loanAmt?: string;
        product?: string;
        subProduct?: string;
        campaignId?: string;
      }>;
    };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "mobile", args.mobile, errorObj, true);
      this.addIfFound(bodyParams, "otp", args.otp, errorObj, true);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/common-api/verify-otp`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async startDdJourney(args: {
    product: string;
    subProduct: string;
    losAppId: string;
  }): Promise<{ result?: {}; error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } } }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "product", args.product, errorObj, true);
      this.addIfFound(bodyParams, "subProduct", args.subProduct, errorObj, true);
      this.addIfFound(bodyParams, "losAppId", args.losAppId, errorObj, true);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/common-api/start-dd-journey`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async getCaptcha(args: {
    temp?: string;
  }): Promise<{
    result?: { img?: string; encryptedValue?: string; iv?: string };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "temp", args.temp, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/common-api/get-captcha`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async validateCaptcha(args: {
    input?: string;
    encryptedValue?: string;
    iv?: string;
  }): Promise<{
    result?: { isValid?: boolean };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "input", args.input, errorObj, false);
      this.addIfFound(bodyParams, "encryptedValue", args.encryptedValue, errorObj, false);
      this.addIfFound(bodyParams, "iv", args.iv, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/common-api/validate-captcha`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async gotNetBankingResponse(args: {
    strTXNREFNO?: string;
    strTXNID?: string;
    strCUSTID?: string;
    strSERVICEID?: string;
    strRETURNCODE?: string;
    strERRORCODE?: string;
    strERRORMSG?: string;
    strCHECKSUM?: string;
  }): Promise<{
    result?: { isValid?: boolean };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "strTXNREFNO", args.strTXNREFNO, errorObj, false);
      this.addIfFound(bodyParams, "strTXNID", args.strTXNID, errorObj, false);
      this.addIfFound(bodyParams, "strCUSTID", args.strCUSTID, errorObj, false);
      this.addIfFound(bodyParams, "strSERVICEID", args.strSERVICEID, errorObj, false);
      this.addIfFound(bodyParams, "strRETURNCODE", args.strRETURNCODE, errorObj, false);
      this.addIfFound(bodyParams, "strERRORCODE", args.strERRORCODE, errorObj, false);
      this.addIfFound(bodyParams, "strERRORMSG", args.strERRORMSG, errorObj, false);
      this.addIfFound(bodyParams, "strCHECKSUM", args.strCHECKSUM, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/common-api/net-banking-response`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            resolve(res);
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async sendNetBankingRequest(args: {
    customerId: string;
    uniqueReferenceNo: string;
  }): Promise<{
    result?: { isValid?: boolean };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "customerId", args.customerId, errorObj, true);
      this.addIfFound(bodyParams, "uniqueReferenceNo", args.uniqueReferenceNo, errorObj, true);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/common-api/net-banking-request`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async resendFinalOtp(args: {
    leadId?: string;
  }): Promise<{ result?: {}; error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } } }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "leadId", args.leadId, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/common-api/resend-final-otp`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async updateHigherLoan(args: {
    customerId?: string;
    promoCode?: string;
    dropOffPromoCode?: string;
    firstName?: string;
    lastName?: string;
    mobileNo?: string;
    email?: string;
    city?: string;
    preApprovedLoanAmt?: string;
    loanRequired?: string;
    product?: string;
    subProduct?: string;
    encryptedInput?: string;
    encryptedValue?: string;
    iv?: string;
  }): Promise<{
    result?: { updated?: boolean };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "customerId", args.customerId, errorObj, false);
      this.addIfFound(bodyParams, "promoCode", args.promoCode, errorObj, false);
      this.addIfFound(bodyParams, "dropOffPromoCode", args.dropOffPromoCode, errorObj, false);
      this.addIfFound(bodyParams, "firstName", args.firstName, errorObj, false);
      this.addIfFound(bodyParams, "lastName", args.lastName, errorObj, false);
      this.addIfFound(bodyParams, "mobileNo", args.mobileNo, errorObj, false);
      this.addIfFound(bodyParams, "email", args.email, errorObj, false);
      this.addIfFound(bodyParams, "city", args.city, errorObj, false);
      this.addIfFound(bodyParams, "preApprovedLoanAmt", args.preApprovedLoanAmt, errorObj, false);
      this.addIfFound(bodyParams, "loanRequired", args.loanRequired, errorObj, false);
      this.addIfFound(bodyParams, "product", args.product, errorObj, false);
      this.addIfFound(bodyParams, "subProduct", args.subProduct, errorObj, false);
      this.addIfFound(bodyParams, "encryptedInput", args.encryptedInput, errorObj, false);
      this.addIfFound(bodyParams, "encryptedValue", args.encryptedValue, errorObj, false);
      this.addIfFound(bodyParams, "iv", args.iv, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/common-api/update-higher-loan`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async updateSanctionLetterStatus(args: {
    isSanctionLetterApproved?: boolean;
  }): Promise<{
    result?: { updated?: boolean };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "isSanctionLetterApproved", args.isSanctionLetterApproved, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/common-api/update-sanction-letter-status`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async encrypt(args: {
    customerId?: string;
  }): Promise<{
    result?: { customerId?: string };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "customerId", args.customerId, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/common-api/encrypt`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            resolve(res);
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async decrypt(args: {
    customerId?: string;
  }): Promise<{
    result?: { customerId?: string };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "customerId", args.customerId, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/common-api/decrypt`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            resolve(res);
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }
}
